// extracted by mini-css-extract-plugin
export default {"root":"Link_root__ZuMYx","inline":"Link_inline__2Cj5j"};